import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { PackageSearch, Menu, } from 'lucide-react';
import ArticleIcon from '@mui/icons-material/Article';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, styled, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';

const sidebarItems = [
  { icon: PackageSearch, label: 'Stock Management', path: '/storemanager/stockmanagement' },
  { icon: ArticleIcon, label: 'Shortage/Damaged', path: '/storemanager/shortage-damage' },
  { icon: AccountCircle , label: 'Profile', path: '/storemanager/profile' },
];

const SidebarDrawer = styled(Drawer)(({ theme }) => ({
  width: 256,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: 256,
    height: 'calc(100vh - 80px)',
    marginTop: '80.4px',
    boxSizing: 'border-box',
    borderRight: `1px solid ${theme.palette.divider}`,
    boxShadow: theme.shadows[3],
    padding: theme.spacing(2),
  },
}));


const StyledNavLink = styled(NavLink)(({ theme }) => ({
  textDecoration: 'none',
  color: 'inherit',
  display: 'block',
  borderRadius: theme.shape.borderRadius,
  transition: 'all 0.2s',
  margin: theme.spacing(0.5, 0),
  '&.active': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
    transform: 'scale(1.05)',
    '& .MuiListItem-root': {
      color: theme.palette.primary.main,
    }
  },
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    transform: 'scale(1.05)',
  }
}));

const StyledListItem = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  borderRadius: theme.shape.borderRadius,
  fontSize: '0.875rem',
  fontWeight: 500,
}));

const MenuButton = styled(IconButton)(({ theme }) => ({
  position: 'fixed',
  top: 10,
  right: 10,
  zIndex: 1200,
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[2],
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  }
}));

const ProductionSidebar = ({ items = sidebarItems }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const sidebarContent = (
    <List>
      {items.map((item, index) => (
        <StyledNavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) => isActive ? 'active' : ''}
          onClick={isMobile ? handleDrawerToggle : undefined}
        >
          <StyledListItem>
            <ListItemIcon sx={{ minWidth: 40 }}>
              <item.icon size={20} />
            </ListItemIcon>
            <ListItemText primary={item.label} />
          </StyledListItem>
        </StyledNavLink>
      ))}
    </List>
  );

  // Mobile view with menu button
  if (isMobile) {
    return (
      <>
        <MenuButton
          color="primary"
          aria-label="open drawer"
          onClick={handleDrawerToggle}
        >
          <Menu size={24} />
        </MenuButton>

        <Drawer
          anchor="left"
          open={open}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            '& .MuiDrawer-paper': {
              width: 256,
              boxSizing: 'border-box',
              padding: theme.spacing(2)
            },
          }}
        >
          {sidebarContent}
        </Drawer>
      </>
    );
  }

  // Desktop view with permanent drawer
  return (
    <SidebarDrawer
      variant="permanent"
      anchor="left"
    >
      {sidebarContent}
    </SidebarDrawer>
  );
}

export default ProductionSidebar;
